import * as React from 'react';
import * as styles from './MobileElementGroup.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../../stores';
import { ElementGroup } from '../elementGroup/ElementGroup';

export interface IMobileElementGroupProps {
  navigatorStore?: NavigatorStore;
  topItemIndex: number;
  elementGroups: any[];
}

@inject('navigatorStore')
@observer
export class MobileElementGroup extends React.Component<IMobileElementGroupProps> {
  render() {
    const elementGroups: JSX.Element[] = [];
    this.props.elementGroups.forEach((column: any[], columnIndex) => {
      column.forEach((elementGroup: any, elementGroupIndex) => {
        elementGroups.push(
          <ElementGroup
            key={`elementGroup_${elementGroupIndex}_${this.props.topItemIndex}_${columnIndex}`}
            config={elementGroup.config}
            elements={elementGroup.elements}
            topItemIndex={this.props.topItemIndex}
            columnIndex={columnIndex}
            index={elementGroupIndex}
            width={window.innerWidth - 40}
            type={elementGroup.type}
          />,
        );
      });
    });
    return (
      <div
        className={styles.mobileElementGroup}
        id={`mobileElementGroup_${this.props.topItemIndex}`}
        style={{
          borderTop:
            this.props.navigatorStore.selectedTopMenuItemIndex == this.props.topItemIndex
              ? `${this.props.navigatorStore.navigator.design.topItems.lineThickness} solid ${this.props.navigatorStore.navigator.design.topItems.textColor}80`
              : 'none',
          backgroundColor: this.props.navigatorStore.navigator.design.elementGroups.backgroundColor,
        }}
      >
        <div>{elementGroups}</div>
      </div>
    );
  }
}
